import { PageSkeleton } from '@app/components/page/header/skeleton/PageSkeleton';
import { Route, useRouteMatch } from 'react-router-dom';
import { PageLoader } from '../../../../components/page/header/skeleton/PageLoader';
import { Page } from '../../../../components/page/Page';
import { FragmentAudiogramTab } from './components/audiogram/AudiogramTab';
import { FragmentContentAiView } from './components/content-ai/FragmentContentAiView';
import { FragmentFilesView } from './components/export/FragmentExportFilesView';
import { FragmentPublishView } from './components/export/FragmentExportPublishView';
import { FragmentsViewHeader } from './components/FragmentsViewHeader';
import { FragmentViewContentSkeleton } from './components/FragmentViewContentSkeleton';
import { FragmentViewPreload } from './components/FragmentViewPreload';
import { FragmentMediaDetail } from './components/media-detail/FragmentMediaDetail';
import { FragmentVideoEditionsTab } from './components/video-editions/tab/FragmentVideoEditionsTab';
import { usePreviewFragment } from './hooks/usePreviewFragment';

/**
 * Fragment detail layout: header, tab routes (info, files, publish, audiogram, video editions, Content AI).
 * Fragment record is provided by {@link RecordCtxProvider} in {@link FragmentsViewPage}.
 */
export function FragmentsViewPage() {
  const { query, fragment } = usePreviewFragment();
  const { path } = useRouteMatch();

  return (
    <PageLoader
      skeleton={
        <PageSkeleton breadcrumbs={2} tabs={4}>
          <FragmentViewContentSkeleton />
        </PageSkeleton>
      }
      query={query}
    >
      <Page htmlTitle={fragment?.title}>
        <FragmentsViewHeader />
        <Page.Content>
          <FragmentViewPreload />
          <Route path={`${path}/content-ai`} render={() => <FragmentContentAiView />} />
          <Route path={`${path}/files`} render={() => <FragmentFilesView />} />
          <Route path={`${path}/publish`} render={() => <FragmentPublishView />} />
          <Route path={`${path}/audiogram`} render={() => <FragmentAudiogramTab />} />
          <Route path={`${path}/video-editions`} render={() => <FragmentVideoEditionsTab />} />
          <Route exact path={path} render={() => <FragmentMediaDetail />} />
        </Page.Content>
      </Page>
    </PageLoader>
  );
}
